/* Header adapter only: the existing cart owns mutations, prices and its drawer. */
(() => {
  const key = '__OE_HEADER_CART__';
  if (window[key]) { window[key].mount(); return; }
  let currentRoot = null, dispose = null;
  function mount() {
    const root = document.querySelector('[data-oe-header]');
    if (root === currentRoot) return;
    dispose?.();
    if (!root || document.documentElement.hasAttribute('data-oe-header-preview')) return;
    currentRoot = root;
    root.dataset.cartConnected = 'true';
    const lifetime = new AbortController();
    const listen = (target, type, handler) => target.addEventListener(type, handler, {signal:lifetime.signal});
    const controls = selector => [...root.querySelectorAll(selector), ...document.querySelectorAll('[data-oe-dock-root] ' + selector)];
    const cartLinks = controls('[data-oe-cart-trigger]');
    const originalFetch = window.fetch;
    const route = (window.Shopify?.routes?.root || '/') + 'cart.js';
    let generation = 0, refreshTimer = 0, request = null, lastCount = null;
    function invalidate() {
      ++generation;clearTimeout(refreshTimer);refreshTimer = 0;
      request?.abort();request = null;
    }
    function render(cart) {
      const count = cart?.item_count;
      if (!Number.isSafeInteger(count) || count < 0) return false;
      if (count === lastCount) return true;
      lastCount = count;
      controls('[data-cart-count]').forEach(el => { el.textContent = String(count); });
      controls('.cart-count-bubble').forEach(el => {
        el.classList.toggle('hidden', count === 0);
        const description = el.querySelector('.visually-hidden');
        if (description) description.textContent = count === 1 ? '1 Artikel' : `${count} Artikel`;
      });
      cartLinks.forEach(link => link.setAttribute('aria-label', `Warenkorb, ${count} Artikel`));
      root.dispatchEvent(new CustomEvent('oe:cart-count', {detail:{itemCount:count}}));
      return true;
    }
    async function refresh() {
      invalidate();
      const own = generation;
      const pending = new AbortController();request = pending;
      try {
        const response = await originalFetch.call(window, route, {credentials:'same-origin', cache:'no-store', signal:pending.signal});
        if (!response.ok) return;
        const cart = await response.json();
        if (!lifetime.signal.aborted && own === generation) render(cart);
      } catch { /* Keep the server-confirmed count during offline/aborted requests. */ }
      finally { if (request === pending) request = null; }
    }
    function schedule() {
      invalidate();
      refreshTimer = setTimeout(refresh, 40);
    }
    const callbacks = [];
    for (const name of ['SLIDECART_LOADED', 'SLIDECART_UPDATED']) {
      const previous = window[name];
      const wrapped = function(cart, ...args) {
        try { return typeof previous === 'function' ? previous.call(this, cart, ...args) : undefined; }
        finally {
          if (!lifetime.signal.aborted) {
            // A confirmed cart callback supersedes both queued and in-flight reads.
            invalidate();
            if (!render(cart)) schedule();
          }
        }
      };
      callbacks.push({name, previous, wrapped});window[name] = wrapped;
    }
    cartLinks.forEach(link => listen(link, 'click', event => {
      if (event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
      if (typeof window.SLIDECART_OPEN !== 'function') return;
      // Call first: if an integration throws, retain the native link default.
      try { window.SLIDECART_OPEN(); }
      catch { return; }
      event.preventDefault();event.stopImmediatePropagation();schedule();
    }));
    // Preserve callers' promises/responses; never clone or read mutation bodies.
    const wrappedFetch = async function(...args) {
      const response = await originalFetch.apply(this, args);
      if (lifetime.signal.aborted) return response;
      try {
        const input = args[0];
        const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
        if (response.ok && url.origin === location.origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(url.pathname)) {
          schedule();
          if (/\/add(\.js)?\/?$/.test(url.pathname)) root.dispatchEvent(new CustomEvent('oe:cart-add-success'));
        }
      } catch { /* Non-URL inputs do not change the caller's behavior. */ }
      return response;
    };
    window.fetch = wrappedFetch;
    for (const type of ['cart:updated','cart:refresh','cart:change']) listen(document, type, schedule);
    listen(window, 'pageshow', schedule);
    listen(document, 'visibilitychange', () => { if (!document.hidden) schedule(); });
    schedule();
    dispose = () => {
      lifetime.abort();invalidate();
      if (window.fetch === wrappedFetch) window.fetch = originalFetch;
      for (const {name, previous, wrapped} of callbacks) if (window[name] === wrapped) window[name] = previous;
      delete root.dataset.cartConnected;currentRoot = null;dispose = null;
    };
  }
  window[key] = {mount};
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    if (currentRoot && event.target.contains(currentRoot)) dispose?.();
  });
  mount();
})();
